import { useLanguage } from '../i18n';

const Hero = ({ setActiveSection }) => {
  const { t } = useLanguage();
  return (
    <section id="home" className="section-shell min-h-screen flex items-center justify-center relative overflow-hidden">
      <div className="absolute inset-0 bg-black/25"></div>

      <div className="section-content text-center px-4 sm:px-6 lg:px-8 py-8 max-w-5xl mx-auto">
        <div className="mb-6 sm:mb-8">
          <img
            src="/nuclearLogo.png"
            alt="Nuclear Team Logo"
            className="pixel-corners w-20 h-20 sm:w-24 sm:h-24 md:w-32 md:h-32 mx-auto animate-float shadow-2xl shadow-purple-500/35"
          />
        </div>
        <h1 className="section-title text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-black mb-4 sm:mb-6 leading-tight">
          NUCLEAR TEAM
        </h1>
        <p className="text-base sm:text-lg md:text-xl text-purple-100 mb-6 sm:mb-8 max-w-2xl mx-auto leading-relaxed px-2">
          {t('studio')}
        </p>
        <div className="flex flex-col sm:flex-row gap-3 sm:gap-4 justify-center items-center px-4">
          <button
            onClick={() => setActiveSection('projects')}
            className="primary-button w-full sm:w-auto px-6 sm:px-8 py-3 rounded-full font-semibold transform hover:-translate-y-0.5 transition-all duration-300 text-sm sm:text-base"
          >
            {t('explore')}
          </button>
          <button
            onClick={() => setActiveSection('contact')}
            className="secondary-button w-full sm:w-auto px-6 sm:px-8 py-3 rounded-full font-semibold transform hover:-translate-y-0.5 transition-all duration-300 text-sm sm:text-base"
          >
            {t('contactUs')}
          </button>
        </div>
      </div>
    </section>
  );
};

export default Hero;
